(() => {
  const selector = document.querySelector('[js-more-shirts-selector]');
  const popup = document.querySelector('[js-shirt-pdp-popup]');
  if (!selector || !popup) return;

  const track = selector.querySelector('[js-more-shirts-track]');
  const prevBtn = selector.querySelector('[js-more-shirts-prev]');
  const nextBtn = selector.querySelector('[js-more-shirts-next]');
  const body = popup.querySelector('[js-shirt-pdp-popup-body]');
  const closeBtns = popup.querySelectorAll('[js-shirt-pdp-close]');


    const updateHeaderZIndex = (isOpen) => {
    const headerStickies = document.querySelectorAll(
      '.template--bridal.collection_header_transparent_new .shopify-section-header-sticky, .shopify-section-header-sticky'
    );
    headerStickies.forEach((header) => {
      if (isOpen) {
        header.style.setProperty('z-index', '1', 'important');
      } else {
        header.style.removeProperty('z-index');
      }
    });
  };


  const openPopup = () => {
    popup.classList.add('popup-open');
    document.body.classList.add('popup-active');
    updateHeaderZIndex(true);
  };

  const closePopup = () => {
    popup.classList.remove('popup-open', 'is-loading');
    document.body.classList.remove('popup-active');
    updateHeaderZIndex(false);
  };

  const updateNav = () => {
    if (!track || !prevBtn || !nextBtn) return;
    const maxScroll = track.scrollWidth - track.clientWidth - 4;
    const canScroll = maxScroll > 0;
    prevBtn.hidden = !canScroll;
    nextBtn.hidden = !canScroll;
    prevBtn.disabled = track.scrollLeft <= 4;
    nextBtn.disabled = track.scrollLeft >= maxScroll;
  };

  const scrollByCard = (direction) => {
    const card = track.querySelector('.more-shirts-selector__item');
    const amount = card ? card.getBoundingClientRect().width + 10 : 100;
    track.scrollBy({ left: amount * direction, behavior: 'smooth' });
  };

  const initAccordion = (root) => {
    root.querySelectorAll('[js-shirt-accordion-header]').forEach((header) => {
      header.addEventListener('click', () => {
        const item = header.closest('.js-accordion-item');
        const isOpen = item.classList.contains('active');
        root.querySelectorAll('.js-accordion-item').forEach((el) => {
          el.classList.remove('active');
          const panel = el.querySelector('[js-shirt-accordion-body]');
          if (panel) panel.hidden = true;
        });
        if (!isOpen) {
          item.classList.add('active');
          const panel = item.querySelector('[js-shirt-accordion-body]');
          if (panel) panel.hidden = false;
        }
      });
    });

    root.querySelectorAll('[js-shirt-product-desc]').forEach((wrap) => {
      const shortDes = wrap.querySelector('.short_des');
      const longDes = wrap.querySelector('.long_des');
      if (!shortDes || !longDes) return;
      wrap.querySelectorAll('.desc_more').forEach((btn) => {
        btn.addEventListener('click', () => {
          const showLong = btn.closest('.short_des');
          shortDes.hidden = Boolean(showLong);
          longDes.hidden = !showLong;
          if (showLong) longDes.removeAttribute('style');
        });
      });
    });
  };

  const addBusinessDays = (numDaysToAdd) => {
    const date = new Date();
    let daysRemaining = parseInt(numDaysToAdd, 10);
    if (Number.isNaN(daysRemaining)) daysRemaining = 3;
    daysRemaining += 1;
    while (daysRemaining > 0) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0) daysRemaining -= 1;
    }
    return date;
  };

  const formatDeliveryDate = (date) => {
    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const day = String(date.getDate()).padStart(2, '0');
    return `${weekdays[date.getDay()]}, ${day} ${months[date.getMonth()]} ${date.getFullYear()}`;
  };

  const setShirtDelivery = (root, days) => {
    const deliveryEl = root.querySelector('[js-shirt-delivery-time]');
    const formattedDate = formatDeliveryDate(addBusinessDays(days));
    if (deliveryEl) deliveryEl.textContent = formattedDate;

    const deliveryInput = root.querySelector('[js-shirt-estimated-delivery-input]');
    if (deliveryInput) deliveryInput.value = formattedDate;

    const daysInput = root.querySelector('[js-shirt-delivery-days-input]');
    if (daysInput) daysInput.value = days;

    const form = root.querySelector('[js-shirt-atc-form], form[data-type="add-to-cart-form"]');
    if (form) {
      form.setAttribute('data-delivery-current-delivery-day-value', days);
    }
  };

  const setShirtPrice = (root, input) => {
    if (!input) return;
    const formattedPrice = input.dataset.variantPrice;
    const formattedCompare = input.dataset.variantCompare;
    const discountLabel = input.dataset.discountLabel;
    const rawPrice = parseInt(input.dataset.variantRawPrice || '0', 10);
    const rawCompare = parseInt(input.dataset.variantRawCompare || '0', 10);
    const isOnSale = rawCompare > rawPrice && Boolean(formattedCompare);

    if (formattedPrice) {
      const atcPrice = root.querySelector('[js-shirt-atc-price], [js-pdp-original-price]');
      if (atcPrice) atcPrice.textContent = formattedPrice;
    }

    const priceRoot = root.querySelector('[js-shirt-price]');
    if (!priceRoot) return;

    const priceContainer = priceRoot.querySelector('.price');
    if (priceContainer) {
      if (isOnSale) {
        priceContainer.classList.add('price--on-sale');
      } else {
        priceContainer.classList.remove('price--on-sale');
      }
    }

    const regularPriceEl = priceRoot.querySelector('.price__regular .price-item--regular');
    if (regularPriceEl && formattedPrice) {
      regularPriceEl.innerHTML = `<span class="price-mrp">MRP</span> ${formattedPrice}`;
      regularPriceEl.setAttribute('data-pdp-product-price', formattedPrice.replace(/[^\d.,]/g, ''));
    }

    const salePriceEl = priceRoot.querySelector('.price__sale .price-item--sale');
    if (salePriceEl && formattedPrice) {
      salePriceEl.textContent = formattedPrice;
      salePriceEl.setAttribute('data-pdp-product-price', formattedPrice.replace(/[^\d.,]/g, ''));
    }

    const comparePriceEl = priceRoot.querySelector('.price__sale s.price-item--regular, .price__sale .price-item--regular');
    if (comparePriceEl) {
      if (isOnSale && formattedCompare) {
        comparePriceEl.innerHTML = `MRP ${formattedCompare}`;
        if (comparePriceEl.parentElement) comparePriceEl.parentElement.style.display = '';
      } else if (comparePriceEl.parentElement) {
        comparePriceEl.parentElement.style.display = 'none';
      }
    }

    const styleNoEl = root.querySelector('[js-shirt-style-no]');
    if (styleNoEl && input.dataset.variantStyleNo) {
      styleNoEl.textContent = `Style No ${input.dataset.variantStyleNo}`;
    }

    let saveBadge = priceRoot.querySelector('.Product_price_save_new');
    if (isOnSale && discountLabel) {
      if (!saveBadge) {
        const saleDiv = priceRoot.querySelector('.price__sale');
        if (saleDiv) {
          saleDiv.insertAdjacentHTML(
            'beforeend',
            `<span class="Product_price_save_new"><span class="Product_price_save_couse_new data-saving-pdp" data-saving="${discountLabel}"></span><span class="Product_price_save_label">${discountLabel}</span><span class="Product_price_save_couse_new"></span></span>`
          );
          saveBadge = priceRoot.querySelector('.Product_price_save_new');
        }
      }
      if (saveBadge) {
        saveBadge.style.display = '';
        const savingEl = saveBadge.querySelector('.data-saving-pdp');
        const labelEl = saveBadge.querySelector('.Product_price_save_label');
        if (savingEl) savingEl.setAttribute('data-saving', discountLabel);
        if (labelEl) {
          labelEl.textContent = discountLabel;
        } else {
          saveBadge.textContent = discountLabel;
        }
      }
    } else if (saveBadge) {
      saveBadge.style.display = 'none';
    }
  };

  const setShirtReturnable = (root, input) => {
    const details = root.querySelector('[js-shirt-product-details]');
    const returnableInput = root.querySelector('[js-shirt-returnable-input]');
    if (!details || !input) return;
    details.classList.remove('non-returnable-variant', 'returnable-variant');
    if (input.dataset.returnable === 'false') {
      details.classList.add('non-returnable-variant');
      if (returnableInput) returnableInput.value = 'False';
    } else if (input.dataset.returnable === 'true') {
      details.classList.add('returnable-variant');
      if (returnableInput) returnableInput.value = 'True';
    }
  };

  const initSizeChart = (root) => {
    const sizeGuideBtn = root.querySelector('[js-shirt-size-guide-open], .sizeguide');
    const sizeChartModal = root.querySelector('.size-chart, [js-pdp-size-chart-popup], [js-shirt-size-chart-popup]');
    if (!sizeGuideBtn || !sizeChartModal) return;

    sizeGuideBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      sizeChartModal.classList.remove('hide');
      sizeChartModal.style.display = 'block';
    });

    const closeBtns = sizeChartModal.querySelectorAll('[js-popup-close-btn], [js-shirt-size-chart-close], .cross-icon');
    closeBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        sizeChartModal.classList.add('hide');
        sizeChartModal.style.display = 'none';
      });
    });

    const inchBtn = sizeChartModal.querySelector('[js-size-convert-btn-inch]');
    const cmBtn = sizeChartModal.querySelector('[js-size-convert-btn-cm]');
    const inchImages = sizeChartModal.querySelectorAll('[data-parameter="in"]');
    const cmImages = sizeChartModal.querySelectorAll('[data-parameter="cm"]');

    if (inchBtn && cmBtn) {
      inchBtn.addEventListener('click', (e) => {
        e.preventDefault();
        inchBtn.classList.add('active');
        cmBtn.classList.remove('active');
        inchImages.forEach((img) => img.classList.remove('visually-hide'));
        cmImages.forEach((img) => img.classList.add('visually-hide'));
      });

      cmBtn.addEventListener('click', (e) => {
        e.preventDefault();
        cmBtn.classList.add('active');
        inchBtn.classList.remove('active');
        cmImages.forEach((img) => img.classList.remove('visually-hide'));
        inchImages.forEach((img) => img.classList.add('visually-hide'));
      });
    }
  };

  const initSizePicker = (root) => {
    const variantInput = root.querySelector('input.product-variant-id');
    const deliveryWrap = root.querySelector('[js-shirt-delivery-wrapper]');
    if (deliveryWrap) setShirtDelivery(root, deliveryWrap.dataset.defaultDays);

    const checkedInput =
      root.querySelector('[js-shirt-size-input]:checked') ||
      root.querySelector('[js-shirt-size-input]:not([disabled])');
    if (checkedInput) {
      setShirtPrice(root, checkedInput);
      if (checkedInput.dataset.deliveryType) {
        const dtInput = root.querySelector('[js-shirt-delivery-type-input]');
        if (dtInput) dtInput.value = checkedInput.dataset.deliveryType;
      }
    }

    root.querySelectorAll('[js-shirt-size-input]').forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        if (variantInput) variantInput.value = input.dataset.variantId;
        setShirtPrice(root, input);
        if (input.dataset.deliveryDays) setShirtDelivery(root, input.dataset.deliveryDays);
        if (input.dataset.deliveryType) {
          const dtInput = root.querySelector('[js-shirt-delivery-type-input]');
          if (dtInput) dtInput.value = input.dataset.deliveryType;
        }
        setShirtReturnable(root, input);
      });
    });
  };

  const initShirtForm = (root) => {
    const form = root.querySelector('[js-shirt-atc-form], form[data-type="add-to-cart-form"]');
    if (!form) return;

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const submitButton = form.querySelector('[type="submit"]');
      const spinner = form.querySelector('.loading__spinner');
      const variantInput = form.querySelector('input.product-variant-id');
      const selectedSize = form.querySelector('[js-shirt-size-input]:checked');

      if (variantInput && variantInput.dataset.requiresSize && !selectedSize) {
        const errorWrap = form.querySelector('[js-pdp-form-error] ul');
        if (errorWrap) errorWrap.innerHTML = '<li>Please select size</li>';
        form.reportValidity();
        return;
      }

      if (selectedSize && variantInput) {
        variantInput.value = selectedSize.dataset.variantId;
        variantInput.removeAttribute('disabled');
      }

      const deliveryEl = root.querySelector('[js-shirt-delivery-time]');
      const deliveryDateText = deliveryEl ? deliveryEl.textContent.trim() : '';
      let deliveryDateInput = form.querySelector('[js-shirt-estimated-delivery-input]');
      if (!deliveryDateInput) {
        deliveryDateInput = document.createElement('input');
        deliveryDateInput.type = 'hidden';
        deliveryDateInput.name = 'items[0][properties][Estimated delivery]';
        deliveryDateInput.setAttribute('js-shirt-estimated-delivery-input', '');
        form.appendChild(deliveryDateInput);
      }
      if (deliveryDateText) {
        deliveryDateInput.value = deliveryDateText;
      }

      const deliveryType = selectedSize?.dataset?.deliveryType || form.querySelector('[js-shirt-delivery-type-input]')?.value || 'RTS';
      let deliveryTypeInput = form.querySelector('[js-shirt-delivery-type-input]');
      if (!deliveryTypeInput) {
        deliveryTypeInput = document.createElement('input');
        deliveryTypeInput.type = 'hidden';
        deliveryTypeInput.name = 'items[0][properties][_Delivery type]';
        deliveryTypeInput.setAttribute('js-shirt-delivery-type-input', '');
        form.appendChild(deliveryTypeInput);
      }
      deliveryTypeInput.value = deliveryType;

      const formData = new FormData(form);
      formData.set('items[0][id]', variantInput ? variantInput.value : formData.get('id'));
      formData.set('items[0][quantity]', '1');
      formData.set('items[0][properties][_Delivery type]', deliveryType);
      formData.delete('id');

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
      }

      if (submitButton) {
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.classList.add('loading');
      }
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      fetch(`${window.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            const errorWrap = form.querySelector('[js-pdp-form-error] ul');
            if (errorWrap) {
              errorWrap.innerHTML = `<li>${response.description || response.message || 'Unable to add this shirt.'}</li>`;
            }
            return;
          }
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(response);
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          }
          closePopup();
        })
        .catch(() => {
          const errorWrap = form.querySelector('[js-pdp-form-error] ul');
          if (errorWrap) {
            errorWrap.innerHTML = '<li>Unable to add this shirt. Please try again.</li>';
          }
        })
        .finally(() => {
          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          }
          if (spinner) spinner.classList.add('hidden');
        });
    });
  };

  const loadShirt = (item) => {
    const handle = item.dataset.shirtHandle;
    const sameAsModel = item.dataset.sameAsModel === 'true';
    const shirtUrl = item.dataset.shirtUrl;
    if (!handle && !shirtUrl) return;
    body.innerHTML = '';
    popup.classList.add('is-loading');
    openPopup();

    const url = shirtUrl
      ? `${shirtUrl}${shirtUrl.includes('?') ? '&' : '?'}view=shirt-pdp-popup`
      : `/products/${handle}?view=shirt-pdp-popup`;

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('Unable to load shirt');
        return response.text();
      })
      .then((html) => {
        body.innerHTML = html;
        const stamp = body.querySelector('[js-same-as-model-stamp]');
        if (stamp) stamp.classList.toggle('is-visible', sameAsModel);
        initAccordion(body);
        initSizePicker(body);
        initSizeChart(body);
        initShirtForm(body);
        if (window.WishlistKing && typeof window.WishlistKing.observe === 'function') {
          try { window.WishlistKing.observe(); } catch(e) {}
        }
      })
      .catch(() => {
        body.innerHTML = '<p class="shirt-pdp-popup__error">Unable to load this shirt. Please try again.</p>';
      })
      .finally(() => {
        popup.classList.remove('is-loading');
      });
  };

  selector.querySelectorAll('[js-more-shirts-item]').forEach((item) => {
    item.addEventListener('click', (event) => {
      event.preventDefault();
      loadShirt(item);
    });
  });

  closeBtns.forEach((btn) => btn.addEventListener('click', closePopup));

  popup.addEventListener('click', (event) => {
    if (event.target === popup) closePopup();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && popup.classList.contains('popup-open')) {
      closePopup();
    }
  });

  popup.addEventListener('shirt-pdp-popup:close', closePopup);

  if (prevBtn && nextBtn && track) {
    prevBtn.addEventListener('click', () => scrollByCard(-1));
    nextBtn.addEventListener('click', () => scrollByCard(1));
    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  }
})();
